import Grid from '@material-ui/core/Grid';
import { styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

export const ActionContent = styled(Grid)({
  justifyContent: 'flex-end',
  display: 'flex'
});

export const ActionLabel = styled(Typography)({
  fontFamily: 'Roboto, sans-serif'
});

export const MoreOptionsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  height: '100%',
  padding: theme.spacing(1)
}));
